import { render, staticRenderFns } from "./VariantSifterGlobalEnrichmentPlot.vue?vue&type=template&id=79c85302&scoped=true&"
import script from "./VariantSifterGlobalEnrichmentPlot.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGlobalEnrichmentPlot.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGlobalEnrichmentPlot.vue?vue&type=style&index=0&id=79c85302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c85302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c85302')) {
      api.createRecord('79c85302', component.options)
    } else {
      api.reload('79c85302', component.options)
    }
    module.hot.accept("./VariantSifterGlobalEnrichmentPlot.vue?vue&type=template&id=79c85302&scoped=true&", function () {
      api.rerender('79c85302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGlobalEnrichmentPlot.vue"
export default component.exports